import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';

import { Observable } from 'rxjs';

import { SiteContent } from '../models';
import { DataService } from '../services/data.service';
import { DataRoutingService } from '../services/data-routing.service';
import { ContentService } from '../services/content.service';

@Injectable({
    providedIn: 'root',
})
export class PageGuard {
    constructor(
        private contentService: DataService,
        private pageContentService: ContentService,
        private router: Router
    ) {}

    getValidPartsFromRoute(
        routingTree: Record<string, any>,
        urlParts: string[]
    ): string {
        const validUrlParts: { i: number; element: string }[] = [];
        const makeValidUrlParts = (tree: Record<string, any>) => {
            urlParts.forEach((element, i) => {
                const isDuplicate = validUrlParts.find(
                    (items) => items.i === i
                );

                if (tree[element] && !isDuplicate) {
                    validUrlParts.push({ i, element });
                    makeValidUrlParts(tree[element]);
                }
            });

            return validUrlParts;
        };

        const url = makeValidUrlParts(routingTree).map(
            (urlParts) => urlParts.element
        );

        return `/${url.join('/')}`;
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const urlParts = state.url.split('/').filter(Boolean);
        const data: SiteContent[] = this.contentService.allData;

        const routingTree = data.reduce(
            DataRoutingService.createRoutingTree,
            {}
        );

        const validUrl = this.getValidPartsFromRoute(routingTree, urlParts);

        //todo: change to an identity check when CMS data is being used.
        if (!validUrl.includes(state.url)) {
            this.router.navigate(['/404']);
        }

        this.pageContentService.setPageDataFromParams(childRoute.params);

        return true;
    }
}
